import React, { Component } from 'react';
import { Consumer } from "../../context";
import DinamicModal from '../dinamicModal/dinamicModal';
import Request from "../../core/httpClient";
import cogoToast from 'cogo-toast';

const request = new Request();

class ConceptModalEddit extends Component {
	constructor(props) {
		super(props);
		this.state = {
			nombre: this.props.datos.nombre,
			id: this.props.datos.id_concepto,
			mostrar_app: this.props.datos.mostrar_app,   // 1 o 0
			cuenta_contable: this.props.datos.cuenta_contable,
		};
	}

	componentDidUpdate(prevProps) {
		if (this.props.datos !== prevProps.datos) {
			this.setState({
				nombre: this.props.datos.nombre,
				id: this.props.datos.id_concepto,
				mostrar_app: this.props.datos.mostrar_app,
				cuenta_contable: this.props.datos.cuenta_contable,
			});
		}
	}

	handleSubmit = async (event) => {

		event.preventDefault();

		const data = {
			id_concepto: this.state.id,
			nombre: this.state.nombre,
			mostrar_app: this.state.mostrar_app,   // lo mando al SP como @p_mostrar_app
			cuenta_contable: this.state.cuenta_contable,
			id_usuario: this.props.context.user.id.id_usuario
		};

		const response = await request.post("/conceptos/concepto/update", data);

		if (response.updated && !response.empty) {
			this.props.reload();
			cogoToast.success('Concepto actualizado.', { position: 'bottom-right' });
		} else {
			cogoToast.error('No se pudo actualizar concepto.', { position: 'bottom-right' });
		}
	};

	render() {
		return (
			<DinamicModal
				idModal={'editBudget'}
				sizeModalContainer={'small'}
				title={'Editar concepto'}
				success={this.handleSubmit}
				showBtnSuccess={this.props.escritura}
				btnTextSuccess={"ACTUALIZAR"}
				showBtnCancel={true}
				btnTextCancel={"CANCELAR"}
				loadingSave={this.state.loadingSave}
				message={this.state.message}
			>
				{this.renderEditBudget()}
			</DinamicModal>
		);
	}

	renderEditBudget() {
		return (
			<div className="full row align-center">
				<div className="column full">
					{/* Sección de Partida */}
					<div className="input-form-content row full align-center">
						<div className="column label-duo-big">
							<p><b>Partida:</b></p>
						</div>
						<div className="column full">
							<input
								type="text"
								name="conceptName"
								id="conceptname"
								value={this.state.nombre}
								onChange={event => this.setState({ nombre: event.target.value })}
								className="input input-modals"
								autoComplete='off'
								maxLength="64"
								required
							/>
						</div>
						<div className="column label-duo-normal align-end">
							<label className="container-check">
								<input
									type="checkbox"
									id="mostrar_app"
									checked={this.state.mostrar_app === 1}
									name="mostrar_app"
									onChange={(event) => {
										this.setState({ mostrar_app: event.target.checked ? 1 : 0 });
									}}
								/>
								<span className="checkmark"></span>
							</label>
						</div>
						<div className="column full">
							<h5><b>Mostrar en la App</b></h5>
						</div>
					</div>

					<div className="white-space-8" />
					<div className="white-space-8" />
					<div className="white-space-8" />

					{/* Sección de Cuenta contable */}
					<div className="input-form-content row full align-center">
						<div className="column label-duo-big">
							<p><b>Cuenta contable:</b></p>
						</div>
						<div className="column full">
							<input
								type="text"
								name="cuenta_contable"
								id="cuenta_contable"
								value={this.state.cuenta_contable}
								onChange={event => this.setState({ cuenta_contable: event.target.value })}
								className="input input-modals"
								autoComplete='off'
								maxLength="64"
							/>
						</div>
					</div>
					<div className="white-space-8" />
				</div>
			</div>
		);
	}
}

export default Consumer(ConceptModalEddit);